import apiRTKQ from 'src/apiRTKQ'

const apiInvoices = apiRTKQ.injectEndpoints({
  endpoints: builder => ({
    fetchBuyers: builder.query({
      query: () => '/supplier/buyers/',
      providesTags: ['Buyers'],
    }),
    fetchInvoice: builder.query({
      query: id => `/supplier/invoices/${id}`,
      providesTags: ['Invoices'],
    }),
    fetchInvoices: builder.query({
      query: () => '/supplier/invoices/',
      providesTags: ['Invoices'],
    }),
    fetchLineItems: builder.query({
      query: params => ({
        url: '/supplier/line-items/',
        params,
      }),
      providesTags: ['LineItems'],
    }),
    fetchOrders: builder.query({
      query: ({ noInvoice }) => ({
        url: '/supplier/orders/',
        params: noInvoice ? { invoice__isnull: true } : {},
      }),
      providesTags: ['Orders'],
    }),
    createInvoice: builder.mutation({
      query: params => ({
        url: '/supplier/invoices/',
        method: 'POST',
        body: params,
      }),
      invalidatesTags: ['Invoices', 'Orders'],
    }),
    editInvoice: builder.mutation({
      query: ({ id, ...params }) => ({
        url: `/supplier/invoices/${id}/`,
        method: 'PATCH',
        body: params,
      }),
      invalidatesTags: ['Invoices'],
    }),
  }),
})

export const {
  useFetchBuyersQuery,
  useFetchInvoiceQuery,
  useFetchInvoicesQuery,
  useFetchLineItemsQuery,
  useFetchOrdersQuery,
  useCreateInvoiceMutation,
  useEditInvoiceMutation,
} = apiInvoices

export default apiInvoices
